import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ variables, breakpoints, palette }) => ({
  messageBanner: {
    background: palette.jet?.supportInfo02,
    width: '100%',
    left: 0,
    minHeight: '100px',
    padding: variables?.spacingD,
    display: 'flex',
    flexDirection: 'row',
    gap: variables?.spacingD,
    alignItems: 'flex-start',
    zIndex: 1,
    position: 'fixed',
    top: 0,
    ['@media (display-mode: standalone)']: {
      ['&.IOS']: {
        marginTop: '50px',
      },
    },
  },
  messageBannerLeft: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: variables?.spacingA,
  },
  messageBannerContent: {},
  messageBannerRight: {},
}));

export default useStyles;
